import {
	ArrowRight,
	DotsThree,
	PencilSimple,
	Trash,
} from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import type { District } from "@/api/districts/types";
import { Button } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useDistrict } from "@/contexts/district-context";
import { useLocalizedNavigate } from "@/hooks/use-localized-navigate";

export type DeleteTarget = { id: number; name: string };
export type RenameTarget = { id: number; name: string };

interface DistrictActionsProps {
	district: District;
	onRename: (t: RenameTarget) => void;
	onDelete: (t: DeleteTarget) => void;
}

export function DistrictActions({
	district,
	onRename,
	onDelete,
}: DistrictActionsProps) {
	const { t } = useTranslation();
	const navigate = useLocalizedNavigate();
	const { setDistrict } = useDistrict();

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant="ghost"
					size="icon"
					aria-label={t("districts.menuMore")}
				>
					<DotsThree className="size-4" weight="bold" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				<DropdownMenuItem
					onClick={() => {
						setDistrict(district.name);
						navigate("apartments");
					}}
				>
					<ArrowRight className="size-4" />
					{t("districts.menuViewApartments")}
				</DropdownMenuItem>
				<DropdownMenuItem
					onClick={() => onRename({ id: district.id, name: district.name })}
				>
					<PencilSimple className="size-4" />
					{t("districts.menuRename")}
				</DropdownMenuItem>
				<DropdownMenuSeparator />
				<DropdownMenuItem
					variant="destructive"
					disabled={district.meters_count > 0}
					onClick={() => onDelete({ id: district.id, name: district.name })}
				>
					<Trash className="size-4" />
					{t("districts.menuDelete")}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
